import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/login.vue';
import Dashboard from './views/dashboard.vue';
import Usuarios from '../src/components/Usuarios/Usuarios';
import Cuenta from '../src/components/Usuarios/Cuenta';
import CrearUsuario from '../src/components/Usuarios/Crear';
import EditarUsuario from '../src/components/Usuarios/Editar';
import Repuestos from '../src/components/Repuestos/Repuestos';
import CrearRepuesto from '../src/components/Repuestos/Crear';
import EditarRepuesto from '../src/components/Repuestos/Editar';
import Clientes from '../src/components/Clientes/Clientes';
import CrearCliente from '../src/components/Clientes/Crear';
import EditarCliente from '../src/components/Clientes/Editar';
import Marcas from '../src/components/Marcas/Marca';
import Tarjetas from '../src/components/Tarjetas/Tarjetas';
import CrearTarjetas from '../src/components/Tarjetas/Crear';
import EditarTarjetas from '../src/components/Tarjetas/Editar';
import OrdeneServicio from '../src/components/OrdenesServicio/Ordenes';
import CrearOrdeneServicio from '../src/components/OrdenesServicio/Crear';
import EditarOrdeneServicio from '../src/components/OrdenesServicio/Editar';
import MisOrdenes from '../src/components/OrdenesServicio/MisOrdenes';
import General from '../src/components/General/General';
import Informes from '../src/components/Informes/Informe';
// import Pagos from '../src/components/Pagos/index';
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    // {
    //     path: '/',
    //     name: 'dashboard',
    //     component: Dashboard
    // },
    {
      path: '/',
      name: 'dashboard',
      component: General,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      component: Usuarios,
    },
    {
      path: '/informes',
      name: 'informes',
      component: Informes,
    },
    {
      path: '/usuarios/crear',
      name: 'crear-usuario',
      component: CrearUsuario,
    },
    {
      path: '/usuarios/editar/:userId',
      name: 'editar-usuario',
      component: EditarUsuario,
    },
    {
      path: '/informacion',
      name: 'informacion',
      component: Cuenta,
    },
    {
      path: '/repuestos',
      name: 'repuestos',
      component: Repuestos,
    },
    {
      path: '/repuestos/crear',
      name: 'crear-repuesto',
      component: CrearRepuesto,
    },
    {
      path: '/repuestos/editar/:repuestoId',
      name: 'editar-repuesto',
      component: EditarRepuesto,
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: Clientes,
    },
    {
      path: '/clientes/crear',
      name: 'crear-cliente',
      component: CrearCliente,
    },
    {
      path: '/clientes/editar/:clienteId',
      name: 'editar-cliente',
      component: EditarCliente,
    },
    {
      path: '/marcas',
      name: 'marcas',
      component: Marcas,
    },
    {
      path: '/tarjetas',
      name: 'tarjetas',
      component: Tarjetas,
    },
    {
      path: '/tarjetas/crear',
      name: 'crear-tarjetas',
      component: CrearTarjetas,
    },
    {
      path: '/tarjetas/editar/:tarjetaId',
      name: 'editar-tarjetas',
      component: EditarTarjetas,
    },
    {
      path: '/ordenes',
      name: 'orden-servicio',
      component: OrdeneServicio,
    },
    {
      path: '/ordenes/crear',
      name: 'crear-orden-servicio',
      component: CrearOrdeneServicio,
    },
    {
      path: '/ordenes/ver/:proviene/:ordenId',
      name: 'editar-orden-servicio',
      component: EditarOrdeneServicio,
    },
    {
      path: '/ordenes/personal',
      name: 'mis-ordenes',
      component: MisOrdenes,
    },
    // {
    //   path: '/pagos',
    //   name: 'pagos',
    //   component: Pagos,
    // },
  ],
});
